import React, { Component } from 'react'
import { withStyles, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { read } from 'actions/data'
import Chart from './Chart'
import language from 'utils/vast-languagepack'

const styles = (theme) => ({
	container: {
		backgroundColor: '#fff',
		padding: '20px 0',
		border: '1px solid gray',
		borderRadius: 20,
		height: 'calc(100vh - 280px)',
		overflowY: 'auto',
		[theme.breakpoints.down('sm')]: {
			height: 'calc(100vh - 220px)',
		},
		[theme.breakpoints.down('xs')]: {
			height: 'calc(100vh - 208px)',
		},
	},
})

export const fieldTypeMap = {
	text: 'textfield',
	number: 'numfield',
	multi: 'fieldvalue',
	bool: 'fieldvalue',
	select: 'fieldvalue',
}

class ChartContainer extends Component {
	componentDidMount() {
		const { sections, read, formID } = this.props

		Promise.allSettled(
			sections
				?.filter?.((section) => section?.type === 'field')
				?.map((section) => {
					return read(
						`${formID}/stats/${fieldTypeMap?.[section?.field?.type]}/${
							section?.field?.field_name
						}`,
						'customFormStat',
						null,
						null,
						'object',
						`${formID}/stats/${fieldTypeMap?.[section?.field?.type]}/${
							section?.field?.field_name
						}`,
					)
				}),
		).then((results) => {
			// console.log(results)
			console.log('allSettled')
		})
	}

	render() {
		const { sections, formID, classes } = this.props

		const filteredSections = sections.filter?.(
			(section) => section?.type === 'field',
		)

		return filteredSections?.length ? (
			<div className={classes.container}>
				{filteredSections?.map((section, idx) => {
					return (
						<Chart
							last={idx === filteredSections.length - 1}
							section={section}
							fieldType={fieldTypeMap?.[section?.field?.type]}
							statsId={`${formID}/stats/${
								fieldTypeMap?.[section?.field?.type]
							}/${section?.field?.field_name}`}
						/>
					)
				})}
			</div>
		) : (
			<Typography variant="h4" gutterBottom>
				{language.signupform.add.responses.noResponses}
			</Typography>
		)
	}
}

export default connect(
	(state) => ({
		sections: state.customForm.addOrEdit?.form?.sections?.map(
			(sectionID) => state.customForm.addOrEdit?.sectionsByID?.[sectionID],
		),
		formID: state.customForm.addOrEdit.id,
	}),
	(dispatch) => bindActionCreators({ read }, dispatch),
)(withStyles(styles)(ChartContainer))
